import React, { Children, isValidElement, useContext } from 'react';
import { View } from '@instructure/ui-view';
import { TableContext } from '@instructure/ui-table';
import { safeCloneElement } from '@instructure/ui-react-utils';
export var Row = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    setRef = _ref.setRef;
  var context = useContext(TableContext);
  var isStacked = context.isStacked;
  var headers = context.headers;
  return /*#__PURE__*/React.createElement(View, {
    as: isStacked ? 'div' : 'tr',
    role: isStacked ? 'row' : void 0,
    elementRef: setRef
    // trick to ensure full height div in cell
    ,
    height: isStacked ? void 0 : '1px'
  }, Children.toArray(children).filter(Boolean).map(function (child, index) {
    if (/*#__PURE__*/isValidElement(child)) {
      return safeCloneElement(child, {
        key: child.props.name,
        isStacked: isStacked,
        header: headers && headers[index]
      });
    }
    return child;
  }));
});
Row.displayName = 'Row';